<template>
  <div v-show="showImage" class="flex-grow-1 d-flex flex-column">
    <div elevation="0" class="flex-grow-1 d-flex flex-column mx-8 pt-4" style='background-color: rgba(255, 255, 255, 0) !important'>
      <v-row>
        <v-col class="flex-grow-1 d-flex flex-column">
          <div :id="'openseadragonImg-Info' + imgViewerName" class="flex-grow-1 d-flex flex-column"></div>
        </v-col>
      </v-row>

      <v-alert
        class="mx-5"
        :value="isDrawing"
        color="grey"
        dense
        border="top"
        icon="mdi-alert"
        transition="scale-transition"
        dismissible
      >
        Drawing not to scale; the proportions of the original may not be reproduced accurately.
      </v-alert>

      <v-card :style=" !isValid(image) ? 'height:525px;background-color: rgba(255, 255, 255, 1) !important;' : 'display: none;height:525px;background-color: rgba(255, 255, 255, 1) !important;'">
        <v-card-title class="justify-center pt-15 font-weight-bold text-h5" style="word-break: break-all;">
          Access to this picture is restricted due to copyright reasons.
        </v-card-title>
        <v-card-text class="pa-10">
          Image published in:<p>
          {{image.copyright}}
          </p>
          <p>For further information, please contact <a href= "mailto:kucha@saw-leipzig.de">the project</a></p>
        </v-card-text>
      </v-card>
    </div>
  </div>

</template>
<script>
import {getOSDURL, setOSDImgInfo} from  "@/utils/helpers"
export default {

  name: 'image',
  components: {

  },
  props: {
    showImage: {
      type: Boolean,
      default: true,
    },
    images: {
      type: Array,
      default: function () {
        return []
      },
    },
    imgViewerName: {
      type: String,
      default: "osdImageViewer"
    },
  },

  data () {
    return {
      renderComponent: true,
      isFullScreen: false,
      tab:[],
      showDescription: false,
      image:{},
      tabImg: null,
      viewerImg :null,
      dialog:false,
      isAllowedPic:true,
      mouseWheelOverlay: false,
      isDrawing: false,
    }
  },
  computed:{
    imageValidDic (){
      return this.$store.getters.getImageValidDic
    },
    user () {
      return this.$store.state.user
    },
  },
  methods: {
    // We need this little trick here, to force tabs to rerender, when user status changed.
    handleScroll(){
      this.$log.debug("scrolling!");
    },
    initOSDimg(){
      let tilesImg = []
      this.$log.debug("Initializing Images: ", this.images);
      if (this.images){
        tilesImg = getOSDURL(this.image)
        this.viewerImg = OpenSeadragon({
          id: 'openseadragonImg-Info' + this.imgViewerName,
          prefixUrl: '/static/',
          tileSources: tilesImg,
          defaultZoomLevel: 1,
          ajaxWithCredentials: true,
          loadTilesWithAjax: true,
          tileRequestHeaders: {"Authorization": this.user.sessionID ? `Bearer ${this.user.sessionID}` : ""},
          ajaxHeaders: {"Authorization": this.user.sessionID ? `Bearer ${this.user.sessionID}` : ""},
        })
        const _self = this
        document.getElementById('openseadragonImg-Info' + this.imgViewerName).addEventListener('fullscreenchange', (event) => {
          if (document.fullscreenElement) {
            _self.isFullScreen = true
          } else {
            _self.isFullScreen = false
          }
        });
        const canvas = document.getElementsByClassName('openseadragon-canvas')[0]
        canvas.style.touchAction = 'pan-y'
        this.$log.debug("canvas.style", canvas.style);

        // Handle desktop scroll
        this.viewerImg.addHandler("pre-full-page", function (data) {
          data.preventDefaultAction = true;
          if (data.eventSource.element.requestFullscreen) {
            data.eventSource.element.requestFullscreen();
          } else if (data.eventSource.element.mozRequestFullScreen) {
            data.eventSource.element.mozRequestFullScreen();
          } else if (data.eventSource.element.webkitRequestFullscreen) {
            data.eventSource.element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          } else if (data.eventSource.element.msRequestFullscreen) {
            data.eventSource.element.msRequestFullscreen();
          } else if (data.eventSource.element.webkitEnterFullScreen) {
            data.eventSource.element.webkitEnterFullScreen(Element.ALLOW_KEYBOARD_INPUT);
          } else {
            var el = document.documentElement;
            el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }
        });
      }
    },
    initImageViewer(){
      if (this.images.length > 0){
        this.$log.debug("started ImageViewer");
        this.$log.debug("Images: ", this.images);
        OpenSeadragon.setString('Tooltips.SelectionToggle', 'Selection Demo');
        OpenSeadragon.setString('Tooltips.SelectionConfirm', 'Ok');
        OpenSeadragon.setString('Tooltips.HorizontalGuide', 'Add Horizontal Guide');
        OpenSeadragon.setString('Tooltips.VerticalGuide', 'Add Vertical Guide');
        OpenSeadragon.setString('Tooltips.ImageTools', 'Image tools');
        OpenSeadragon.setString('Tool.brightness', 'Brightness');
        OpenSeadragon.setString('Tool.contrast', 'Contrast');
        OpenSeadragon.setString('Tool.thresholding', 'Thresholding');
        OpenSeadragon.setString('Tool.invert', 'Invert');
        OpenSeadragon.setString('Tool.gamma', 'Gamma');
        OpenSeadragon.setString('Tool.greyscale', 'Greyscale');
        OpenSeadragon.setString('Tool.reset', 'Reset');
        OpenSeadragon.setString('Tool.rotate', 'Rotate');
        OpenSeadragon.setString('Tool.close', 'Close');
        if (this.images.length > 0){
          this.image = this.images[0]
          if (this.image.imageTypeID === 5){
            this.isDrawing = true
          } else {
            this.isDrawing = false
          }
          if (!this.viewerImg){
            this.initOSDimg()
          }
        }
      }
    },
    isValid(image){
      if (image){
        if (image.imageID){
          if (this.imageValidDic[image.imageID]){
            return this.imageValidDic[image.imageID].valid ? this.imageValidDic[image.imageID].valid : false
          }
        } else if (image.caveID){
          if (this.imageValidDic["cave-" + image.caveSketchID]){
            return this.imageValidDic["cave-" + image.caveSketchID].valid ? this.imageValidDic["cave-" + image.caveSketchID].valid : false
          }
        }
      }
      return false
    },
    getThumbnail(image){
      return this.imageValidDic[image.imageID].thumbnail
    },
    mouseOver: function(){
      this.showDescription = !this.showDescription
    },
    setOSDimages(image){
      this.image = image
      if (this.image.imageTypeID === 5){
        this.isDrawing = true
      } else {
        this.isDrawing = false
      }
      this.viewerImg.open(getOSDURL(image))
      // this.setOSDImgOverlayImg()
    },
  },
  watch: {

    'images': function (newVal, oldVal) {
      this.initImageViewer()
      this.$store.dispatch('buildImageValidDic', this.images)
    },

    user: {
      handler(val){
        this.$store.dispatch('buildImageValidDic', this.images)
      },
      deep: true
    }
  },
  mounted:function () {
    console.log("osdIMGViewer", this.images);
    this.initImageViewer()
  },
  beforeMount:function(){
  }
}
</script>

<style lang="css">
.hidden {
  visibility: hidden;
}

.visible {
  visibility: visible;
}
.v-item-group {
  background-color: transparent !important;
}
.transparent-tabs {
  background-color: transparent !important;
  box-shadow: none !important;
}
.transparent-tabs .v-tab {
  background-color: transparent !important;
}

.transparent-tabs .v-tabs-bar {
  background-color: transparent !important;
}
.transparent-tabs .v-v-item-group {
  background-color: transparent !important;
}
</style>